import React from "react";
import { useLocation } from "react-router-dom";

import FDPrint from "./FDPrint";
import LoanPrint from "./LoanPrint";
import InsurancePrint from "./InsurancePrint";

export default function PrintWrapper() {
  const location = useLocation();

  const type = location.state?.type;
  const data = location.state?.data;

  if (!data) return <p>No data found</p>;

  switch (type) {
    case "fd":
      return <FDPrint data={data} />;

    case "loan":
      return <LoanPrint data={data} />;

    case "insurance":
      return <InsurancePrint data={data} />;

    default:
      return <p>Invalid print type</p>;
  }
}
